import { Component, OnInit } from '@angular/core';
import { UserDataService } from '../../remote/data-storage/user-data.service';
import { AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { TranslateService } from '@ngx-translate/core';
import { ViewChild } from '@angular/core';
import { MeetingService } from '../services/meeting.service';
import { Meeting } from '../../../dtos/meeting';
import * as moment from 'moment-timezone';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { AgoraRtmService } from '../services/agora-rtm.service';
import { OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-join-meeting',
    templateUrl: './join-meeting.component.html',
    styleUrls: ['./join-meeting.component.scss']
})
export class JoinMeetingComponent implements OnInit, AfterViewInit, OnDestroy {

    constructor(private userDataService: UserDataService,
                private router: Router, public globalDataService: GlobalDataService,
                private route: ActivatedRoute,
                private translate: TranslateService,
                private meetingService: MeetingService,
                private apiConfigService: ApiConfigService,
                private agoraRtmService: AgoraRtmService) {

    }

    joining: boolean;
    openLoginWindow: boolean;
    images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
    waitingMessage: string = 'N/A';
    meeting: Meeting;
    flowLoading: boolean;
    error: boolean;
    @ViewChild("passJoin")
    elementInput: any;
    facts: any;
    selectedFact: any;
    meetingCode: string;

    private persistRtmClient: boolean;

    ngOnInit(): void {
        this.apiConfigService.get('api/facts/all').subscribe((facts) => {
            this.facts = facts['data'];
            this.selectedFact = this.facts[0];
        })
    }

    ngOnDestroy(): void {
        if (this.meeting && !this.persistRtmClient) {
            this.agoraRtmService.channels["meeting_" + this.meeting.id].channel.off("ChannelMessage", this.channelEventHandler.bind(this));
            this.agoraRtmService.logoutRtmClient("meeting_" + this.meeting.id);
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (!this.userDataService.getUser().id) {
                this.openLoginWindow = true;
            }
        }, 100)
        this.route.params.subscribe(params => {
            let meetingCode = params['code'];
            if (meetingCode) {
                this.meetingCode = meetingCode;
                this.joinMeeting();
            }
        });
    }

    joinMeeting() {
        this.error = false;
        this.meetingCode = this.meetingCode ? this.meetingCode : this.elementInput.nativeElement.value;
        if (!this.userDataService.getUser().id) {
            this.elementInput.nativeElement.value = this.meetingCode;
            this.openLoginWindow = true;
        } else {
            if (this.meetingCode) {
                this.flowLoading = true;
                this.meetingService.checkMeetingCode(this.meetingCode)
                    .subscribe((meeting: Meeting) => {
                        this.error = false;
                        this.meeting = meeting;
                        this.countDown(meeting.timestamp);
                        this.agoraRtmService.initAgoraClients("meeting_" + meeting.id + "_"+ 'local_'  + this.userDataService.getUser().id, "meeting_" + meeting.id)
                            .then(() => {
                                this.flowLoading = false;
                                this.joining = true;
                                //start a meeting if its already started or the user is the guide
                                if (meeting.started || meeting.culturalRoute.user.id === this.userDataService.getUser().id) {
                                    this.redirectToMeeting();
                                } else {
                                    this.agoraRtmService.channels["meeting_" + meeting.id].channel.on("ChannelMessage", this.channelEventHandler.bind(this))
                                }
                            })
                    }, (error) => {
                        this.error = true;
                        this.meetingCode = null;
                        this.flowLoading = false;
                    })
            } else {
                this.error = true;
                this.meetingCode = null;
            }
        }
    }

    selectFact(fact) {
        this.selectedFact = fact;
    }

    redirectToMeeting() {
        this.persistRtmClient = true;
        this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/meeting-room/'+this.meetingCode]);
    }

    private channelEventHandler(...args) {
        const messageObject = JSON.parse(args[0].text);
        //JSON.parse(messageObject)
        if(messageObject.type === 'INIT_TOUR'){
            this.redirectToMeeting();
        }
    }

    private countDown(date: string) {
        const pad = (n) => {
            return (n < 10 ? "0" + n : n);
        }
        const countDownDate = moment(date).tz('Europe/Athens').valueOf();
        // Update the count down every 1 second
        const x = setInterval(() => {

            // Get todays date and time
            const now = moment().tz('Europe/Athens').valueOf();

            // Find the distance between now an the count down date
            const distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Output the result in an element with id="demo"
            this.waitingMessage = 'The tour will be start in ' + pad(days) + "d " + pad(hours) + "h "
                + pad(minutes) + "m " + pad(seconds) + "s ";

            // If the count down is over, write some text
            if (distance < 0) {
                clearInterval(x);
                this.waitingMessage = 'The tour will be start soon';
            }
        }, 1000);
    }

}
